export const goHTMLPosition = (id: string): void => {
  // 平滑前往 id 元素位置
  (document.getElementById('html') as HTMLElement).setAttribute('style', 'scroll-behavior: smooth')
  document.documentElement.scrollTop = (document.getElementById(id) as HTMLElement).offsetTop - 50;
  (document.getElementById('html') as HTMLElement).setAttribute('style', 'scroll-behavior: auto')
}
